import { shouldDetachRutaAiForViewport } from '@/contexts/RutaAiContext';

/**
 * How the detached (unanchored) Ruta AI panel sits on screen.
 *
 * Phone width used `absolute right-3` plus Framer Motion `drag` inside a
 * `fixed inset-0` shell. Motion measures the node before it has a width and
 * writes a large negative `x`, so the card paints off-screen to the left —
 * only a sliver of shadow stays in the viewport (RUT-3910 bounce).
 *
 * Narrow viewports lock both `left` and `right` (no `right`-only + drag).
 * Desktop keeps a right-floating card via flex `justify-end`, not `right`.
 */
export function detachedRutaAiFillsViewport(width?: number): boolean {
  return shouldDetachRutaAiForViewport(width);
}

export function detachedRutaAiShellClass(fillsViewport: boolean): string {
  return fillsViewport
    ? 'fixed inset-0 z-50 pointer-events-none'
    : 'fixed inset-0 z-50 pointer-events-none flex justify-end items-start p-3';
}

export function detachedRutaAiPanelClass(fillsViewport: boolean): string {
  return fillsViewport
    ? 'pointer-events-auto fixed left-3 right-3 top-3 h-[calc(100dvh-1.5rem)] max-h-[calc(100dvh-1.5rem)] w-auto max-w-none'
    : 'pointer-events-auto relative w-[400px] h-[calc(100vh-1.5rem)] max-h-[760px] max-w-[calc(100vw-1.5rem)]';
}

export function detachedRutaAiAllowsDrag(fillsViewport: boolean): boolean {
  return !fillsViewport;
}
